<template>
  <li>
    <router-link :to="{ name: 'agencies.edit', params: { id: agency.id } }">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-8 d-flex align-items-center">
          <p class="text-truncate strong2">{{ agency.name }}</p>
        </div>

        <div class="col-6 col-md-3 col-lg-2 d-flex align-items-center">
          <p>
            <span class="data-label mt-0">Hosted Graduates</span>
            {{ agency.hosted_graduates }}
          </p>
        </div>

        <div class="col-6 col-md-3 col-lg-2 d-flex align-items-center">
          <p>
            <span class="data-label mt-0">Home Graduates</span>
            {{ agency.home_graduates }}
          </p>
        </div>
      </div><!-- /.row -->
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    agency: {
      required: true,
      type: Object
    }
  }
}
</script>
